import React, { useState, useContext } from 'react';

import { ClashesTable, ModalContext } from 'school-space-client/components';
import {
    ApiAvailabilityError,
    ApiActionFailedError,
    ApiValidationError
} from 'school-space-client/errors';
import { IconButton, Snackbar } from '@material-ui/core';
import { Close, Info } from '@material-ui/icons';

import NotificationContext from './NotificationContext';
import ValidationErrorDetails from './ValidationErrorDetails';

const displayErrorDetails = error => {
    if (error instanceof ApiAvailabilityError) {
        return <ClashesTable clashes={error.data} />;
    }

    if (error instanceof ApiActionFailedError) {
        return (
            <ul>
                {error.data.map(({ id, error: failureError }) => (
                    <details>
                        <summary>{id}</summary>
                        <div>{failureError.toString()}</div>
                    </details>
                ))}
            </ul>
        );
    }

    if (error instanceof ApiValidationError) {
        return <ValidationErrorDetails errors={error.data} />;
    }

    return <p>{JSON.stringify(error.data)}</p>;
};

const Notification = () => {
    const [autoHideDuration, setAutoHideDuration] = useState(3000);
    const { notificationIsShowing, message, error, hideNotification } = useContext(
        NotificationContext
    );
    const {
        openModal,
        types: { information }
    } = useContext(ModalContext);

    const hideInfo = () => {
        setAutoHideDuration(3000);
        hideNotification();
    };

    const showInfo = () => {
        openModal({
            type: information,
            props: {
                title: error.message,
                cancelText: 'Close message',
                closeAction: hideInfo,
                hideButton: true,
                message: () => (error.data ? displayErrorDetails(error) : null)
            }
        });
        setAutoHideDuration(null);
    };

    return (
        <>
            <Snackbar
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center'
                }}
                open={notificationIsShowing}
                autoHideDuration={autoHideDuration}
                onClose={() => {
                    hideNotification();
                }}
                ClickAwayListenerProps={{
                    mouseEvent: false
                }}
                message={message}
                action={[
                    error ? (
                        <IconButton key="info" color="inherit" onClick={showInfo}>
                            <Info />
                        </IconButton>
                    ) : (
                        <IconButton key="close" color="inherit" onClick={hideNotification}>
                            <Close />
                        </IconButton>
                    )
                ]}
            />
        </>
    );
};

export default Notification;
